import { Reveal } from "../site/Motion";
import { SectionLabel } from "../site/Bits";
import { PhoneMockup } from "../site/PhoneMockup";
import StoreButtons from "../site/StoreButtons";
import { APP_SCREENSHOTS } from "../../lib/site";

export const Showcase = () => (
  <section className="relative overflow-hidden bg-background py-24" data-testid="showcase-section">
    <div className="mesh-glow pointer-events-none absolute inset-0" />
    <div className="relative mx-auto grid max-w-7xl grid-cols-1 items-center gap-16 px-5 lg:grid-cols-2 lg:px-8">
      <div>
        <SectionLabel>See it in action</SectionLabel>
        <h2 className="mt-5 font-display text-4xl font-bold leading-tight tracking-tight text-ink sm:text-5xl">
          Your renewals, beautifully organised.
        </h2>
        <p className="mt-5 max-w-lg text-base leading-relaxed text-slate-600">
          A clean, focused mobile experience that shows exactly what needs attention next — colour-coded by urgency, with reminders that reach you in time. Available now on Google Play. Coming soon to the App Store.
        </p>
        <StoreButtons className="mt-8" />
        <p className="mt-4 text-xs text-slate-400">Actual screens from the RenewTracker app.</p>
      </div>

      <Reveal className="relative flex justify-center gap-6">
        <div className="mt-10 hidden sm:block">
          <PhoneMockup image={APP_SCREENSHOTS.items} alt="RenewTracker items list" floatBadge={false} className="scale-90 opacity-95" />
        </div>
        <PhoneMockup image={APP_SCREENSHOTS.dashboard} alt="RenewTracker dashboard" />
      </Reveal>
    </div>
  </section>
);

export default Showcase;
